import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    page: { type: Number, default: 0 }
  }
  
  static targets = ["sentinel", "loading"]
  
  connect() {
    this.observer = new IntersectionObserver(
      entries => this.handleIntersection(entries),
      {
        root: this.element.closest('.overflow-y-auto'),
        rootMargin: '100px',
        threshold: 0
      }
    )
    
    if (this.hasSentinelTarget) {
      this.observer.observe(this.sentinelTarget)
    }
    
    this.loading = false
  }
  
  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
  
  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting && !this.loading) {
        this.loadMore()
      }
    })
  }
  
  async loadMore() {
    if (this.loading) return
    
    this.loading = true
    this.pageValue += 1
    
    // Show loading indicator
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.remove('hidden')
    }
    
    try {
      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.set('page', this.pageValue)
      
      const response = await fetch(url, {
        headers: {
          'Accept': 'text/vnd.turbo-stream.html',
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        }
      })
      
      if (response.ok) {
        const html = await response.text()
        
        // Process the turbo stream response
        Turbo.renderStreamMessage(html)
        
        // Check if we should continue observing
        // The response will append new items and update the sentinel
        // If there's no more data, the sentinel will be removed
      } else {
        console.error('Failed to load more feedback:', response.statusText)
      }
    } catch (error) {
      console.error('Error loading more feedback:', error)
    } finally {
      this.loading = false
      
      // Hide loading indicator
      if (this.hasLoadingTarget) {
        this.loadingTarget.classList.add('hidden')
      }
    }
  }
}


